// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_DCG","cls2":"SingularMentionCitationModal-cls2_kP8 SingularMentionCitationModal-cls1_DCG"};